<template>
  <v-layout row justify-center>
    <v-dialog v-model="dialog" persistent max-width="600px">
      <template v-slot:activator="{ on }"> 
         
        <v-btn class="px-0 mx-0" flat color="black" v-on="on">
          <span>Accedi</span>
          <v-icon class="hidden-md-only" right>account_circle</v-icon>
        </v-btn>
      </template>
      <v-card>
        <v-card-title>
          <span class="headline">Accedi</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              
              <v-flex xs12>
                <v-text-field v-model="email" label="Email*" required @keyup.enter="loginSubmitted"></v-text-field>
              </v-flex>
              <v-flex xs12 v-show="!recupero">
                <v-text-field v-model="password" label="Password*" type="password" required @keyup.enter="loginSubmitted"></v-text-field>
              </v-flex>
              <v-flex xs12 v-show="recupero">
                <small class="text-uppercase"> Inserire E-mail per cui si desidera reimpostare la password </small>
              </v-flex>
              <v-flex xs12> Accedi con : </v-flex>
              <v-flex xs12>
                <v-btn flat class="blue darken-3 white--text" @click="accediByFacebook()">Facebook</v-btn>
                <v-btn  @click="accediByGoogle()"> 
                  <span class="blue--text">G</span>
                  <span class="red--text">o</span>
                  <span class="orange--text">o</span>
                  <span class="blue--text">g</span>
                  <span class="green--text">l</span>
                  <span class="red--text">e</span>
                </v-btn>
              </v-flex>

            </v-layout>
          </v-container>
          <small class="red--text">{{ messaggio }}</small> <br>
          <small>*indicates required field</small>
        </v-card-text>

        <v-btn color="blue justify-content-center darken-1" flat @click="reimpostaPswd()">Reimposta Password</v-btn>  

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click="dialog = false, recupero = false">Chiudi</v-btn>
          <v-btn v-if="!recupero" color="blue darken-1" flat @click="loginSubmitted">Accedi</v-btn>
          <v-btn v-else color="blue darken-1" flat @click="inviaPswd()">Invia</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import fb from "@/fb"
import firebase from 'firebase'
import EventBus from '../eventBus'
export default {
  data () { 
    return {
      dialog: false,
      dialog1: false,
      email: null,
      password: null,
      messaggio: "",
      recupero: false
    }
  },
  methods: {
  loginSubmitted() {
    if (this.recupero == false) {
      fb.auth.signInWithEmailAndPassword(this.email, this.password).then( () => {
        this.email = null
        this.password = null
        this.dialog = false
      }).catch(err => this.messaggio = err.message)  
    } else {
      fb.auth.sendPasswordResetEmail(this.email).then(() => {
        this.dialog = false
        this.recupero = false
      })
    }
    EventBus.$emit('login-effettuato')
  },
  reimpostaPswd() {
    this.recupero = true
  },
  inviaPswd() {
    fb.auth.sendPasswordResetEmail(this.email).then(() => {
      this.dialog = false
      this.recupero = false
      EventBus.$emit('login-effettuato')
    })
  },
  accediByFacebook() {
    var provider = new firebase.auth.FacebookAuthProvider()
    fb.auth.signInWithPopup(provider).then( () => {
        this.email = null
        this.password = null
        this.dialog = false
        EventBus.$emit('login-effettuato')
    }).catch(err => this.messaggio = err.message)
  },
  accediByGoogle() {
    var provider = new firebase.auth.GoogleAuthProvider()
    fb.auth.signInWithPopup(provider).then( () => {
        this.email = null
        this.password = null
        this.dialog = false
        EventBus.$emit('login-effettuato')
    }).catch(err => this.messaggio = err.message)
  }  
 }
}
</script>

<style>

</style>
